import c0 from './annotations_controller';
import c1 from './autocomplete_controller';
import c2 from './browser_extension_controller';
import c3 from './clipboard_controller';
import c4 from './dropzone_controller';
import c5 from './history_controller';
import c6 from './inplace_input_controller';
import c7 from './login_form_controller';
import c8 from './menu_controller';
import c9 from './panel_controller';
import c10 from './pass_reveal_controller';
import c11 from './remote_controller';
import c12 from './remover_controller';
import c13 from './request_controller';
import c14 from './scroll_progress_controller';
import c15 from './scroll_tracker_controller';
import c16 from './scrollto_controller';
import c17 from './styler_controller';
import c18 from './theme_controller';
import c19 from './timetoken_controller';
import c20 from './turbo_form_controller';
import c21 from './turbo_refresh_controller';
import c22 from './turbo_reload_controller';
import c23 from './video_controller';
export const definitions = [
	{identifier: 'annotations', controllerConstructor: c0},
	{identifier: 'autocomplete', controllerConstructor: c1},
	{identifier: 'browser-extension', controllerConstructor: c2},
	{identifier: 'clipboard', controllerConstructor: c3},
	{identifier: 'dropzone', controllerConstructor: c4},
	{identifier: 'history', controllerConstructor: c5},
	{identifier: 'inplace-input', controllerConstructor: c6},
	{identifier: 'login-form', controllerConstructor: c7},
	{identifier: 'menu', controllerConstructor: c8},
	{identifier: 'panel', controllerConstructor: c9},
	{identifier: 'pass-reveal', controllerConstructor: c10},
	{identifier: 'remote', controllerConstructor: c11},
	{identifier: 'remover', controllerConstructor: c12},
	{identifier: 'request', controllerConstructor: c13},
	{identifier: 'scroll-progress', controllerConstructor: c14},
	{identifier: 'scroll-tracker', controllerConstructor: c15},
	{identifier: 'scrollto', controllerConstructor: c16},
	{identifier: 'styler', controllerConstructor: c17},
	{identifier: 'theme', controllerConstructor: c18},
	{identifier: 'timetoken', controllerConstructor: c19},
	{identifier: 'turbo-form', controllerConstructor: c20},
	{identifier: 'turbo-refresh', controllerConstructor: c21},
	{identifier: 'turbo-reload', controllerConstructor: c22},
	{identifier: 'video', controllerConstructor: c23},
];
